export const CSV_EXPORT_COLUMNS = [
	'companyName',
	'companyEmail',
	'companyPhone',
	'addressCity',
	'websiteUrl',
	'aiScore',
	'contactName',
	'contactEmail',
	'contactRole',
];

export const CSV_COLUMN_GROUPS = {
	company: {
		label: 'Firmendaten',
		columns: [
			{ key: 'companyId', label: 'Unternehmens-ID' },
			{ key: 'companyName', label: 'Firmenname' },
			{ key: 'companyEmail', label: 'Firmen E-Mail' },
			{ key: 'companyPhone', label: 'Firmen Telefon' },
			{ key: 'companyMobilePhone', label: 'Firmen Mobil' },
			{ key: 'addressStreet', label: 'Straße' },
			{ key: 'addressPostal', label: 'PLZ' },
			{ key: 'addressCity', label: 'Stadt' },
			{ key: 'websiteUrl', label: 'Website' },
		],
	},
	ai: {
		label: 'KI-Analyse Daten',
		columns: [
			{ key: 'aiScore', label: 'KI-Score (%)' },
			{ key: 'aiCriteria', label: 'KI-Kriterien Status' },
			{ key: 'aiReasoning', label: 'KI-Begründung' },
			{ key: 'aiEvidence', label: 'KI-Evidenz' },
		],
	},
	contact: {
		label: 'Kontaktdaten',
		columns: [
			{ key: 'contactId', label: 'Kontakt-ID' },
			{ key: 'contactName', label: 'Kontakt Name' },
			{ key: 'contactRole', label: 'Kontakt Position' },
			{ key: 'contactEmail', label: 'Kontakt E-Mail' },
			{ key: 'contactPhone', label: 'Kontakt Telefon' },
			{ key: 'contactPhoneType', label: 'Kontakt Telefon-Typ', requiresCapability: 'phone.access' },
			{ key: 'contactDirectDial', label: 'Kontakt Durchwahl', requiresCapability: 'phone.access' },
		],
	},
	financial: {
		label: 'Finanzkennzahlen',
		columns: [
			{ key: 'revenue', label: 'Umsatz' },
			{ key: 'earnings', label: 'Gewinn' },
			{ key: 'balanceTotal', label: 'Bilanzsumme' },
			{ key: 'employeeCount', label: 'Mitarbeiter' },
		],
	},
};
